// extracted by mini-css-extract-plugin
export var circle = "_b1-1";
export var exitConfirmationModal = "_b1-5";
export var iframe = "_b1-0";
export var offline = "_b1-3";
export var online = "_b1-2";
export var workstationSelectError = "_b1-4";